import FormantNode from './FormantNode.js';
import Tone from 'tone';

const NUMBER_FORMANTS = 8;

export default class Formants {
    constructor(oscillator) {
        this.oscillator = oscillator;
        this.input = new Tone.Gain(0.3);
        this.output = new Tone.Gain(1);
        this.analyser = new Tone.Analyser('fft', 256);
        this.input.connect(this.output);
        this.output.connect(this.analyser);
        this.bypassConnected = true;

        this.formants = [];
        for (let i=0; i < NUMBER_FORMANTS; i++) {
            this.formants.push(new FormantNode(this, i));
        }
    }

    dispose() {
        this.formants.forEach(f => f.dispose());
        this.input.dispose();
        this.output.dispose();
        this.analyser.dispose();
        this.input = undefined;
        this.output = undefined;
        this.analyser= undefined;
    }

    anyFormantsOn() {
        return this.formants.some(
            f => f.enabled);
    }

    numFormants() {
        return this.formants.filter(
            f => f.enabled).length;
    }

    enableFormants() {
        // signal will now only go from input, through
        // formants and then the output
        if (this.bypassConnected) {
            this.input.disconnect(this.output);
            this.bypassConnected = false;
        }
    }

    disableFormants() {
        // signal will bypass the formants, going directly
        // from input to output
        if (!this.bypassConnected) {
            this.input.connect(this.output);
            this.bypassConnected = true;
        }
    }
}
